module.exports = __webpack_public_path__ + "static/fipcbluefloral2-cacd76bd350d73d7f1cc207a6eb46559.jpeg";